import axios from "axios";
import {API_DOMAIN} from "../constants";

const CLAIM_CATEGORIES_URL = API_DOMAIN + "/api/v3/auth/claimCategories";

// GET /api/v3/auth/claimCategories
// Returns [{id, name, displayName, displayOrder, claimCount}], ordered by display order.
export async function getClaimCategories() {
    const response = await axios({
        url: CLAIM_CATEGORIES_URL,
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

// GET /api/v3/auth/claimCategories/{id}
// Returns {id, name, displayName, displayOrder, claimCount, claims: [{claimType, claimValue, displayName}]}.
export async function getClaimCategory(id) {
    const response = await axios({
        url: `${CLAIM_CATEGORIES_URL}/${id}`,
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

// POST /api/v3/auth/claimCategories  (Global Admin)
// Payload: {name, displayName, displayOrder}. Returns the detail shape. 409 if the name is already in use.
export async function createClaimCategory(payload) {
    const response = await axios({
        url: CLAIM_CATEGORIES_URL,
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });

    return response.data;
}

// PUT /api/v3/auth/claimCategories/{id}  (Global Admin)
// Payload: {name, displayName, displayOrder}. Returns the detail shape. 409 if the name is already in use, 404 if unknown.
export async function updateClaimCategory(id, payload) {
    const response = await axios({
        url: `${CLAIM_CATEGORIES_URL}/${id}`,
        method: "PUT",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });

    return response.data;
}

// DELETE /api/v3/auth/claimCategories/{id}  (Global Admin)
// 204 on success. 409 if the category still has claims assigned, 404 if unknown.
export async function deleteClaimCategory(id) {
    return axios({
        url: `${CLAIM_CATEGORIES_URL}/${id}`,
        method: "DELETE",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });
}
